import { render } from "./AddQ.vue?vue&type=template&id=01527376&scoped=true"
import script from "./AddQ.vue?vue&type=script&lang=js"
export * from "./AddQ.vue?vue&type=script&lang=js"

import "./AddQ.vue?vue&type=style&index=0&id=01527376&scoped=true&lang=css"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01527376"]])

export default __exports__